import { Iframe } from "../services/iframe";
import { MessageBus } from "../services/messageBus";
import { GtpService } from "../services/gtpService";
import { Analytics } from "../services/analytics";
import { StateManager } from "../services/stateManager";

// Application
export type OnStartCallbackPropsType = {
  selector: string;
  metadata: Record<string, string>;
  sport: string;
  widgetType: string;
  headerDisabled?: string;
};

export type Context = {
  iframe: Iframe;
  msgBus: MessageBus;
  stateMngr: StateManager;
  gtpService: GtpService;
  analytics: Analytics;
};

export type Handler<Payload = unknown> = (payload: Payload, ctx: Context) => void | Promise<void>;

export type HandlersRegistry = {
  [key: string]: Handler;
};

// IFRAME
export type AnalyticsPayload = {
  accaName: string;
  carouselPosition: number;
  hasReason: true;
};

export type IframeSelectionDetail = {
  marketId: string;
  legacySelectionId: string;
  handicap?: number;
};

export type IframeSelectionPayload = {
  analytics: AnalyticsPayload;
  byoSelectionDetails: IframeSelectionDetail[];
  legacyEventId: string;
  byoPrice?: {
    numerator: number;
    denominator: number;
    byoMarketId: string;
  };
};

// Odds Format
export type NavigationPayload = {
  page: string;
  eventId?: string;
};

const enum OddsFormatsBetslip {
  DECIMAL = "decimal",
  AMERICAN = "american",
  FRACTIONAL = "fractional",
  FRACTION = "fraction",
}

export const OddsFormatIframe = {
  [OddsFormatsBetslip.DECIMAL]: "decimal",
  [OddsFormatsBetslip.AMERICAN]: "american",
  [OddsFormatsBetslip.FRACTIONAL]: "fractional",
  [OddsFormatsBetslip.FRACTION]: "fractional",
} as const;

export type OddsFormatPayload = OddsFormatsBetslip;

export type DataType = {
  data: {
    source: string;
    action: string;
    payload?: any;
  };
};

export type EventType = {
  data: DataType;
  origin: string;
};

// BetSlip
export type ByoSelectionDetail = {
  selectionId: string;
  handicap?: number;
};

type ByoPrice = {
  type: string;
  numerator: number;
  denominator: number;
};

export type BYOSelectionPayload = {
  byoEventId: string;
  byoMarketId: string;
  byoSelectionDetails: ByoSelectionDetail[];
  byoPrice: ByoPrice;
  analytics: AnalyticsPayload & {
    BetListName: string[];
    EventCategory?: string;
    EventAction?: string;
    EventLabel?: string;
    ElementType?: string;
    FeatureDescription?: string[];
    ProductName?: string[];
    ProductAreaName?: string[];
    EventName?: string[];
  };
};
export type BetSlipBetInfo = {
  editable: boolean;
  selectionId: string;
  selectionNames: string[];
  eventName: string;
  marketName: string;
  eventId: string;
  prices: Array<{
    type: string;
    numerator: number;
    denominator: number;
  }>;
  eventDateStartTime: string;
  selectedPriceIndex: number;
  startingPriceToggleAvailable: boolean;
  handicap: string;
  isInPlay: boolean;
  selectionDetails: Array<{
    selectionId: string;
    name: string[];
    description: string;
    marketId: string;
    handicap?: number;
  }>;
  betUid: string;
};

export type BetSlipUpdatePayload = {
  [betUid: string]: BetSlipBetInfo;
};

// GTP
export type GtpTranslations = {
  [obId: string]: string;
};

export type BetSlipMappingResponse = {
  status: "ok";
  traceId: string;
  mappings: GtpTranslations;
};

// StateManager
export type IframeSelections = {
  byoSelectionDetails: IframeSelectionDetail[];
};
